import {useDebounce} from "./useDebounce";
import {useEffect, useState} from "react";

export const useElementSize = (el) => {
  const [size, setSize] = useState({width: el?.clientWidth || 10, height: el?.clientHeight || 10});
  const onResize = useDebounce(() => {
    if (el?.clientWidth && el?.clientHeight) {
      setSize({width: el.clientWidth, height: el.clientHeight});
    }
  }, 250);

  useEffect(() => {
    if (!el) return;

    // Set up ResizeObserver even if element currently has zero dimensions.
    // This handles the case where the element gets dimensions after initial render
    // (e.g., when CSS layout is applied or tab becomes visible).
    const resizeObserver = new ResizeObserver(() => {
      if (el.clientWidth && el.clientHeight) {
        setSize({width: el.clientWidth, height: el.clientHeight});
      }
    });
    resizeObserver.observe(el);

    // If element already has dimensions, update state immediately
    if (el.clientWidth && el.clientHeight) {
      setSize({width: el.clientWidth, height: el.clientHeight});
    }

    return () => resizeObserver.disconnect();
  }, [el]);

  return size;
};
